import { setAuthToken, clearAuthTokens } from '../../../utils/authSession';
import { getAuthHeaders } from '../../../utils/authHeaders';

export class OAuthSessionExpiredError extends Error {}

export const requestOAuthConsent = async (url, options = {}) => {
    const response = await fetch(url, {
        ...options,
        headers: { ...getAuthHeaders({ includeRefreshToken: true }), ...options.headers },
        credentials: 'include'
    });

    if (response.status === 401) {
        throw new OAuthSessionExpiredError('Luckynote sign-in required');
    }

    const renewedToken = response.headers.get('x-token');
    if (renewedToken) {
        setAuthToken(renewedToken);
    }
    return response;
};

export const redirectToOAuthLogin = (search, clearSession = false) => {
    if (clearSession) {
        clearAuthTokens();
    }
    // Login consumes "redirect"; reload so its route guard sees the cleared session.
    window.location.replace(`/login?redirect=${encodeURIComponent(`/oauth/consent${search}`)}`);
};
